<template>
  <div class="echartsModules" ref="echartsModules">
    <a-drawer
      title="折旧预测总额"
      placement="right"
      :visible="visible"
      @close="handleCancel"
      width="85%"
      :destroyOnClose="true"
      :headerStyle="headerStyle"
    >
      <div class="modelDiv">
        <div class="leftDiv">
          <div class="treeDiv">
            <dept-tree
              ref="deptTree"
            ></dept-tree>
          </div>
          <a-divider />
          <div class="treeDiv2">
            <asset-tree ref="assetTree"></asset-tree>
          </div>
        </div>
        <div class="rightDiv">
          <search-tab :searchModel="searchModel"></search-tab>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import deptTree from '@/views/assetLedger/modules/echartsModules/deptTree'
import assetTree from '@/views/assetLedger/modules/echartsModules/assetTree'
import searchTab from '@/views/assetLedger/modules/echartsModules/searchTab'
import moment from 'moment'
import { mapActions } from 'vuex'
export default {
  name: 'EchartsModules',
  components: {
    deptTree,
    assetTree,
    searchTab
  },
  computed: {
  },
  data () {
    return {
      visible: false,
      headerStyle: {
        textAlign: 'center'
      },
      // 搜索条件
      searchModel: {},
      // 是否显示总资产购置价格
      showPrice: true
    }
  },
  created () {
  },
  methods: {
    ...mapActions(['handleActiveTabs']),
    open (visible) {
      this.visible = visible
    },
    setSearchModel (searchModel) {
      this.searchModel = searchModel
    },
    handleCancel () {
      this.visible = false
    },
  }
}
</script>

<style scoped lang="less">
.modelDiv {
  //display: flex;
  height: 100%;
  .leftDiv {
    height: 100%;
    width: 200px;
    border-right: 1px solid #DDDDDD;
    padding-right: 10px;
    display: inline-block;
    float: left;
    .treeDiv {
      height: calc(48% - 10px);
      overflow-y: hidden;
    }
    .treeDiv2 {
      height: calc(51% - 10px);
      overflow-y: hidden;
    }
  }
  .allAssetPurchasePriceDiv {
    width: calc(100% - 200px);
    height: 50px;
    display: inline-block;
    padding-left: 10px;
    position: relative;
    margin-bottom: 12px;
  }
  .allAssetPurchasePriceDiv span{
    display: inline-block;
    width: 100%;
    background-color: rgba(8, 64, 159, 0.1);
    text-align: center;
    line-height: 50px;
    font-size: 18px;
    font-weight: 500;
  }
  .rightDiv {
    width: calc(100% - 200px);
    height: calc(100% - 50px);
    padding-left: 10px;
    position: relative;
    display: inline-block;
    .changeTimeDiv {
      display: flex;
      position: absolute;
      top: 6px;
      right: 0;
      .changeTimeBtn {
        margin-right: 10px;
        padding: 5px 10px;
        border-radius: 5px;
        cursor: pointer;
        transition: all 0.4s;
      }
      .changeTimeBtnActive {
        color: #ffffff;
        background: rgb(24, 144, 254);
        transition: all 0.4s;
      }
      /deep/.ant-calendar-picker-container {
        top: 40px !important;
      }
      .ant-calendar-picker {
        width: 180px;
      }
    }
  }
}
/deep/.ant-drawer-body {
  height: calc(100% - 55px);
  padding: 10px 24px 24px 24px;
}
/deep/.ant-tabs {
  height: 100%;
  .ant-tabs-content {
    height: calc(100% - 57px);
  }
}
</style>
